import { render, staticRenderFns } from "./UserGroupInfo.vue?vue&type=template&id=c2d8d9f2&scoped=true"
import script from "./UserGroupInfo.vue?vue&type=script&lang=js"
export * from "./UserGroupInfo.vue?vue&type=script&lang=js"
import style0 from "./UserGroupInfo.vue?vue&type=style&index=0&id=c2d8d9f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d8d9f2",
  null
  
)

export default component.exports